






















import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
    name: 'ModalWindow'
})
export default class Modal extends Vue {
    @Prop({ default: true }) overflowIsAuto: boolean;
}
